// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"TimeMetrics_contentWrapper__F1b_b"};